

















































































import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import { CajaChicaTalca } from "@/typings/store/plugins/easyFirestore/cajaChicasTalca";

@Component({})
export default class InfoCajaChicaTalca extends Vue {
  @Prop() readonly cajaChicaTalca!: CajaChicaTalca;
  @Prop({ type: Boolean }) readonly showTitulo!: boolean;

  get numero(): string {
    return this.cajaChicaTalca.numero?.toString() ?? "N/R";
  }

  get fecha(): string {
    const f = this.cajaChicaTalca.fecha;
    if (typeof f === "string") return f || "N/R";
    if (f && typeof (f as { toDate?: () => Date }).toDate === "function") {
      return (f as { toDate: () => Date }).toDate().format?.("DD-MM-YYYY") ?? "N/R";
    }
    return "N/R";
  }

  get rutProveedor(): string {
    return this.cajaChicaTalca.rutProveedor ?? "N/R";
  }

  get nombreProveedor(): string {
    return this.cajaChicaTalca.nombreProveedor ?? "N/R";
  }

  get accion(): string {
    return this.cajaChicaTalca.accion ?? "N/R";
  }

  get ingresoFormateado(): string {
    const v = this.cajaChicaTalca.ingreso;
    if (v === undefined || v === null || v === "") return "-";
    const num = typeof v === "string" ? parseFloat(String(v).replace(/\./g, "").replace(",", ".")) : Number(v);
    if (Number.isNaN(num)) return "-";
    return "$ " + Math.round(num).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }

  get egresoFormateado(): string {
    const v = this.cajaChicaTalca.egreso;
    if (v === undefined || v === null || v === "") return "-";
    const num = typeof v === "string" ? parseFloat(String(v).replace(/\./g, "").replace(",", ".")) : Number(v);
    if (Number.isNaN(num)) return "-";
    return "$ " + Math.round(num).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }

  get documento(): string {
    return this.cajaChicaTalca.documento ?? "N/R";
  }

  get concepto(): string {
    return this.cajaChicaTalca.concepto ?? "N/R";
  }

  get descripcion(): string {
    return this.cajaChicaTalca.descripcion ?? "N/R";
  }

  textoAutor(quien?: string, cuando?: string): string {
    const partes = [quien, cuando].filter((parte) => !!parte);
    return partes.join(" · ");
  }

  get registroTexto(): string {
    const texto = this.textoAutor(this.cajaChicaTalca.creadoPor, this.cajaChicaTalca.creadoEn);
    return texto || "Sin registro";
  }

  get edicionTexto(): string {
    return this.textoAutor(this.cajaChicaTalca.editadoPor, this.cajaChicaTalca.editadoEn);
  }

  get archivo(): { url?: string; file?: File } | null {
    const arch = this.cajaChicaTalca.archivo;
    if (!arch || typeof arch !== "object") return null;
    const first = Object.values(arch)[0];
    return first ?? null;
  }

  get tieneComprobante(): boolean {
    return !!(this.archivo && (this.archivo.url || this.archivo.file));
  }

  get urlComprobante(): string {
    const a = this.archivo;
    if (!a) return "";
    if (a.url) return a.url;
    if (a.file) return URL.createObjectURL(a.file);
    return "";
  }

  @Emit("cerrar")
  onCerrar(): void {
    return;
  }
}
